// @flow

import React, { Component } from 'react'
import { Layout, ImageHeader, Caption, BodyTitle, Logo, TitleHeader, RichText } from './Sections'

type RichTextContentProps = {
  title: string,
  logoUrl: string,
  caption: ?string,
  html: string,
  thumbnail: ?string,
  hashtags: string[]
}
class RichTextContent extends Component <RichTextContentProps, {}> {
  getHeader () {
    const { title, thumbnail } = this.props
    if (thumbnail) {
      return <ImageHeader src={thumbnail} />
    }

    return <TitleHeader title={title} useParallax />
  }

  getBody () {
    const { logoUrl } = this.props
    const title = this.getBodyTitle()
    const caption = this.getCaption()
    const richText = this.getRichText()
    return (
      <div>
        <Logo src={logoUrl} />
        {title}
        {caption}
        {richText}
      </div>
    )
  }

  getBodyTitle () {
    const { title, thumbnail } = this.props
    if (!thumbnail) {
      return null
    }

    return <BodyTitle title={title} usePadding={false} />
  }

  getCaption () {
    const { caption, logoUrl, hashtags } = this.props
    if (!caption) {
      return null
    }
    return <Caption usePadding={!logoUrl} caption={caption} hashtags={hashtags} />
  }

  getRichText () {
    const { html } = this.props
    return <RichText html={html} />
  }

  render () {
    const { logoUrl } = this.props
    const header = this.getHeader()
    const body = this.getBody()
    return (
      <Layout isRichText header={header} body={body} usePadding={!logoUrl} useParallax />
    )
  }
}

export default RichTextContent
